import React, { Component, Fragment } from "react";
import { Form, Input, Table, Modal, Radio, DatePicker, Spin } from "antd";
import moment from "moment";
import Api from "../../../services/ServiceApi";
import Cookies from "js-cookie";

// const { RangePicker } = DatePicker;
class Division extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: 0,
      menu: [
        { icon: "ma_list.svg", title: "MA List", link: "" },
        {
          icon: "ma_team_service.svg",
          title: "MA Team Service",
          link: "/ma_team_service",
        },
        { icon: "", title: "Material Stock", link: "/material_stock" },
        {
          icon: "notifications.svg",
          title: "Notifications",
          link: "/notifications",
        },
        { icon: "report.svg", title: "Report", link: "/report" },
        { icon: "", title: "Setting", link: "/setting" },
      ],
      visible: false,
      value: 1,
      title: "Division",
      data: [],
      master_data: [],
      job_id: 0,
      columns: [
        {
          title: "Division ID",
          // dataIndex: "division_id",
          align: "center",
          render: (item) => (!item.division_id ? "-" : item.division_id),
          key: "division_id",
          sorter: (a, b) => 
          (a.division_id === null || a.division_id  === undefined ? 0 : a.division_id) -
          (b.division_id === null || b.division_id  === undefined ? 0 : b.division_id),  
        },
        {
          title: "Division Name",
          align: "center",
          render: (item) => (!item.division_name ? "-" : item.division_name),
          key: "division_name",
          sorter: (a, b) => 
          (a.division_name === null || a.division_name  === undefined ? "" : a.division_name).localeCompare
          (b.division_name === null || b.division_name  === undefined ? "" : b.division_name),          
        },
        {
          title: "Create by",
          render: (item) => (!item.create_by ? "-" : item.create_by),
          align: "center",
          key: "create_by",
          sorter: (a, b) => 
          (a.create_by === null || a.create_by  === undefined ? 0 : a.create_by) -
          (b.create_by === null || b.create_by  === undefined ? 0 : b.create_by),         
         },
        {
          title: "Effective date",
          key: "effective_date",
          align: "center",
          render: (item) =>
            !item.effective_date ? (
              "-"
            ) : (
              <div>{moment(item.effective_date).format("DD/MM/YYYY")}</div>
            ),
            sorter: (a, b) => 
            (a.effective_date === null || a.effective_date  === undefined ? "" : a.effective_date).localeCompare
            (b.effective_date === null || b.effective_date  === undefined ? "" : b.effective_date),  
        },
        {
          title: "Expired date",
          key: "expire_date",
          align: "center",
          render: (item) =>
            !item.expire_date ? (
              "-"
            ) : (
              <div>{moment(item.expire_date).format("DD/MM/YYYY")}</div>
            ),
            sorter: (a, b) => 
            (a.expire_date === null || a.expire_date  === undefined ? "" : a.expire_date).localeCompare
            (b.expire_date === null || b.expire_date  === undefined ? "" : b.expire_date),  
        },
        {
          title: "Status",
          dataIndex: "is_active",
          key: "is_active",
          align: "center",
          render: (item) => (
            <div>
              {item === 0 ? (
                <span className="c-red">
                  <span className="dot-Inactive mr-2"></span>InActive
                </span>
              ) : (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              )}
            </div>
          ),
          sorter: () => null,
        },
        {
          title: "Action",
          align: "center",
          render: (item) => (
            <div>
              <a onClick={() => this.onModal("Edit", true, item)}>
                <img src={Api.absoluteUrl("/icon/Edit.svg")} />
              </a>
            </div>
          ),
          sorter: () => null,
        },
      ],
      modal_item: {},
      err_log: "",
      visible_approve: false,
      visible_delete: false,
    };
  }

  async componentDidMount() {
    const result = await Api.post("get_division", {
      pk_id: null,
      is_active: 1,
      sql_where: " and company_id=" + Cookies.get("companyid") + " and operator_id=" +  Cookies.get("operator_id"),
    });
    if (result.data.result.code === "P") {
      this.setState({
        //data: result.data.data.division_dto_list,
        data: result.data.data,
        master_data: result.data.data,
        loading: false,
      });
    } 
  }

  async handleSubmit(values) {
    const { mode, modal_item } = this.state;

    if(mode === "Add"){
      
    var dataset = {
      "company_id":   Cookies.get("companyid"),
      "operator_id":  Cookies.get("operator_id"),
      "project_id":   Cookies.get("project_id"),
      "division_id": null,
      "division_name": values.division_name,
      "is_active": 1,
      "effective_date": moment(values.effective_date).format("YYYY-MM-DD"),
      "expire_date": moment(values.expire_date).format("YYYY-MM-DD"),
      "create_date": moment(new Date()).format("YYYY-MM-DD HH:mm"),
      "create_by":  Cookies.get("username"),
      "form_id": "",
      "data_dynamic": null
    };

    Api.post("v2/update_division", dataset)
    .then((val) => {
      if(val.data.result.code.toLowerCase() === "p"){
        this.OnViewApprove(this.renderApproveButtonModal());
        this.formRef.current.resetFields();
         Api.post("get_division", {
          pk_id: null,
          is_active: 1,
          sql_where: " and company_id=" + Cookies.get("companyid") + " and operator_id=" +  Cookies.get("operator_id"),
        }).then((result)   => {
          if (result.data.result.code === "P") {
            this.setState({
              //data: result.data.data.division_dto_list,
              data: result.data.data,
              master_data: result.data.data,
              loading: false,
            });
          } 
        })
      } else {
        // alert("Error:" + val.data.result.showtext);
        this.setState({
          err_log: val.data.result.showtext
        })
        this.OnViewReject(this.renderRejectButtonModal());
      }
    })

    } else if (mode === "Edit"){
      var dataset = {
        "company_id":   Cookies.get("companyid"),
        "operator_id":  Cookies.get("operator_id"),
        "project_id":   Cookies.get("project_id"),
        "division_id": modal_item.division_id,
        "division_name": values.division_name,
        "is_active": 1,
        "effective_date": moment(values.effective_date).format("YYYY-MM-DD"),
        "expire_date": moment(values.expire_date).format("YYYY-MM-DD"),
        "create_date": moment(new Date()).format("YYYY-MM-DD HH:mm"),
        "create_by":  modal_item.create_by,
        "form_id": "",
        "data_dynamic": null
      };
  
      Api.post("v2/update_division", dataset)
      .then((val) => {
        if(val.data.result.code.toLowerCase() === "p"){
          this.OnViewApprove(this.renderApproveButtonModal());
          this.formRef.current.resetFields();
           Api.post("get_division", {
            pk_id: null,
            is_active: 1,
            sql_where: " and company_id=" + Cookies.get("companyid") + " and operator_id=" +  Cookies.get("operator_id"),
          }).then((result)   => {
            if (result.data.result.code === "P") {
              this.setState({
                //data: result.data.data.division_dto_list,
                data: result.data.data,
                master_data: result.data.data,
                loading: false,
              });
            } 
          })
        } else {
          this.setState({
            err_log: val.data.result.showtext
          })
          this.OnViewReject(this.renderRejectButtonModal());
        }
      })
    }

    // await this.props.submit(dataset);


  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
  };

  async onModal(mode, visible, item) {
    console.log(item);
    if (visible === false) {
      this.setState({ visible: visible });
      this.formRef.current.resetFields();
    } else {
      await this.setState({
        mode: mode,
        visible: visible,
      });
      if (mode === "Edit") {
        // var form = await item;
        // this.setState({
        //   job_id: form.job_category_id,
        // });
        // this.formRef.current.setFieldsValue({
        //   job_category_name: form.job_category_name,
        //   date: [moment(form.effective_date), moment(form.expire_date)],
        //   is_active: form.is_active,
        // });
        this.setState({
          modal_item: item,
        })
        await this.formRef.current.setFieldsValue({
          is_active: item.is_active,
          division_name: item.division_name,
          effective_date: moment(item.effective_date),
          expire_date: item.expire_date? moment(item.expire_date) : null,
        })
      }
    }
  }

  renderModal() {
    const { visible, title, mode, loading } = this.state;
    return (
      <Modal
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            {mode} {title}
          </span>
        }
        centered
        visible={visible}
        footer={null}
        closable={false}
        // ref={this.formRef}
      >
        <Spin spinning={loading}>
          <div className="row justify-content-center">
            <div className="col-8">
              <Form
                onFinish={(values) => this.handleSubmit(values)}
                layout="vertical"
                ref={this.formRef}
              >
                {mode == "Edit" ? (
                  <Form.Item
                    name="is_active"
                    label="Status"
                    rules={[{ required: true, message: "Status is required" }]}
                  >
                    <Radio.Group>
                      <Radio value={1}>
                        <span className="font-thai-r fs-18">Active</span>
                      </Radio>
                      <Radio value={0}>
                        <span className="font-thai-r fs-18">Inactive</span>
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                ) : null}

                <Form.Item
                  name="division_name"
                  label="Division Name"
                  rules={[
                    { required: true, message: "Division name is required" },
                  ]}
                >
                  <Input
                    className="font-mont-r fs-12"
                    type="text"
                    size="large"
                    placeholder="Please Input"
                  />
                </Form.Item>
                <Form.Item
                  name="effective_date"
                  label="Effective Date"
                  rules={[
                    {
                      required: true,
                      message: "Expire date is required",
                    },
                  ]}
                >
                  <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
                </Form.Item>
                <Form.Item
                  name="expire_date"
                  label="Expire Date"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Expire date is required",
                  //   },
                  // ]}
                >
                  <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
                </Form.Item>
                <Form.Item className="mb-0 text-center">
                  <button
                    type="reset"
                    onClick={() => this.onModal("", false)}
                    className="btn btn-secondary"
                  >
                    Cancel
                  </button>
                  <button className="btn btn-success" type="submit">{mode}</button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }

    //Approve Modal
  renderApproveButtonModal() {
      const { visible_approve, mode } = this.state;
      return (
        <Fragment>
          <Modal
            centered
            visible={visible_approve}
            footer={null}
            closable={false}
            width={300}
            bodyStyle={{
              paddingTop: "0",
              paddingLeft: "15px",
              paddingRight: "15px",
              paddingBottom: "0",
            }}
          >
            <div className="p-3">
              <div className="row">
                <div className="col text-center justify-content-between">
                  {window.location.hostname == "localhost" ? (
                    <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                  ) : (
                    <img src={Api.absoluteUrl("./icon/approve_check.svg")} />
                  )}
                </div>
              </div>
  
              <div className="row" style={{ margin: "20px 10px 20px 10px" }}>
                <div className="col text-center justify-content-between">
                  <span
                    style={{
                      fontFamily: "MontserratM",
                      fontWeight: "bold",
                      color: "#0500A3",
                    }}
                  >
                      {mode} Successful
                  </span>
                </div>
              </div>
  
              <div className="row">
                <div className="col text-center justify-content-between">
                  <button
                    type="reset"
                    style={{ height: "30px", width: "100px" }}
                    onClick={() =>
                      this.setState({
                        visible_approve: false,
                        visible_delete: false,
                        visible: false,
                      })
                    }
                    className="btn btn-warning"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </Fragment>
      );
  }
  
    //Reject modal
  renderRejectButtonModal() {
      const { visible_reject } = this.state;
      return (
        <Fragment>
          <Modal
            centered
            visible={visible_reject}
            footer={null}
            closable={false}
            width={300}
            bodyStyle={{
              paddingTop: "0",
              paddingLeft: "15px",
              paddingRight: "15px",
              paddingBottom: "0",
            }}
          >
            <div className="p-3">
              <div className="row">
                <div className="col text-center justify-content-between">
                    <img src={Api.absoluteUrl("./icon/reject.svg")} />
                </div>
              </div>
  
              <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
                <div className="col text-center justify-content-between">
                    <span style={{ color: "red" }}>
                          Add Permission Failed. <br/>
                          {this.state.err_log}
                    </span>
                </div>  
              </div>
  
              <div className="row">
                <div className="col text-center justify-content-between">
                  <button
                    type="reset"
                    style={{ height: "30px", width: "100px" }}
                    onClick={() =>
                      this.setState({ visible_reject: false, visible: false, err_log: "" })
                    }
                    className="btn btn-warning"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </Fragment>
      );
  }

    // Opening approve
  OnViewApprove() {
      this.setState({
        visible_approve: true,
      });
  }
  
    // Open Failed Modal
  OnViewReject() {
      this.setState({
        visible_reject: true,
      });
  }

  Search =  async(value) => {
    console.log(value);
    const {master_data} = this.state;
    await this.setState({
      data: [],
    })
    if(value != undefined){
      var setdata = [];
      var obj = {};
          for (let i = 0; i < master_data.length; i++) {
              for (const [key, value] of Object.entries(master_data[i])) {
                  if (value == null || value == undefined) {
                  obj[`${key}`] = "-"
                  } else {
                  obj[`${key}`] = `${value}`
                  }
              }
              setdata.push(obj);
              obj = {};
          }        
      const filter_table = setdata.filter((o) =>
      Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.toLowerCase().trim())
      )
      );
      console.log(filter_table);
      this.setState({
          data: filter_table
      })
    } else {
      this.setState({
        data: master_data
    })
    }
  }

  render() {
    const { title, data, columns } = this.state;
    return (
      <div>
        {this.state.visible_approve ? this.renderApproveButtonModal() : null}
        {this.state.visible_reject ? this.renderRejectButtonModal() : null}
        <span className="font-mont-r fs-12">Basic Data</span>
        <h3 className="font-mont-sb fs-18 c-blue">{title}</h3>
        <div className="d-flex justify-content-between my-3">
          <Input.Search
            placeholder="Search"
            onSearch={this.Search}
            allowClear
            style={{ width: 200 }}
          />
          <button
            className="btn btn-warning"
            onClick={() => this.onModal("Add", true)}
          >
            <img src={Api.absoluteUrl("/icon/plus.svg")} className="mr-2" />
            Add {title}
          </button>
        </div>
        <Table columns={columns} dataSource={data} rowKey="division_id" />
        {this.renderModal()}
      </div>
    );
  }
}

export default Division;
